export const swiperAllSliders = (tabsList, tabsWrap, index) => {
    tabsList.slideToLoop(index);
    tabsWrap.slideToLoop(index);
};